import { http } from "@/http";

export default {
  getAll() {
    return http.get("/api/v1/vehicle-types");
  },
  list(data, params) {
    return http.post('/api/v1/vehicle-types/list', data, { params })
  },
  save(data) {
    return http.post("/api/v1/vehicle-types", data);
  },
  get(id) {
    return http.get(`/api/v1/vehicle-types/${id}`);
  },
  update(id, data) {
    return http.put(`/api/v1/vehicle-types/${id}`, data);
  },
  changeStatus(id, status) {
    return http.put(`/api/v1/vehicle-types/${id}/status`, null, {
      params: { status },
    });
  },
};
